module.exports = __webpack_public_path__ + "static/img/time-line-mob-gold.c5619b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/time-line-mob-gold.png
// module id = 1060
// module chunks = 173